import { Form as AntdForm, Input } from 'antd'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import StepRowList from './StepRowList'

type StepNameListProps = {
  addLabel: ReactNode
  /** The form field holding `{ name }[]`. */
  name: string | Array<string>
  testId: string
}

/**
 * A list of people recorded by name, e.g. witnesses: a "Name" input per person
 * with Remove, and Add below. Blank rows are dropped by `toNamedPeople` on save.
 */
const StepNameList = ({ addLabel, name, testId }: StepNameListProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <StepRowList
      addLabel={addLabel}
      label={t(incidentReportsConstants.CASE_V2_NAME)}
      name={name}
      newRow={{ name: '' }}
      renderInput={(row, index, id) => (
        <AntdForm.Item name={[row.name, 'name']} noStyle>
          <Input data-testid={`${testId}-name-${index}`} id={id} />
        </AntdForm.Item>
      )}
      testId={testId}
    />
  )
}

export default StepNameList
